import { APICore } from './apiCore'

const api = new APICore()

function getSurveys (params) {
  const baseUrl = '/survey'
  return api.get(baseUrl, params)
}

function getSurvey (id) {
  const baseUrl = `/survey/${id}`
  return api.get(baseUrl, {})
}

function addSurvey (params) {
  const baseUrl = '/survey'
  return api.create(baseUrl, params)
}
function duplicateSurvey (params) {
  const baseUrl = '/survey/duplicate'
  return api.create(baseUrl, params)
}
function updateSurvey (params) {
  const baseUrl = '/survey'
  return api.update(baseUrl, params)
}

function deleteSurvey (params) {
  const baseUrl = '/survey'
  return api.delete(baseUrl, params)
}

export { getSurveys, getSurvey, addSurvey, duplicateSurvey, updateSurvey, deleteSurvey }
